import { connect } from 'react-redux';

import { replyToReview } from '../Ratings.saga';
import ReplyToReviewForm from './ReplyToReviewForm';

const mapDispatchToProps = (dispatch, { reviewId }) => ({
  onSubmit: (values, formAsyncFns) => dispatch(replyToReview(reviewId, values, formAsyncFns)),
});

export default connect(null, mapDispatchToProps)(ReplyToReviewForm);
